import type { CommerceRegistryThemePalette } from '../../../domain/commerce-registry/models/commerce-registry-theme-palette.model';

/**
 * Leal skeleton defaults when RTDB does not send `commerce_theme` / sends partial colors
 * (aligned with applyCommerceRegistrySkeletonTheme + :root in styles/commerce-registry-theme.scss).
 */
export const defaultCommerceRegistryThemePalette: CommerceRegistryThemePalette = {
  primary: '#fed600',
  secondary: '#101223',
  tertiary: '#fcfcfe',
  textHint: 'rgba(16, 18, 35, 0.45)',
  input: 'transparent',
};
